import React, {useEffect, useState} from 'react';
import $ from "jquery";
import moment from "moment";
import {
    GET_COLLECTION_AGGREGATE_DATA
} from "../../api";
import cogoToast from "cogo-toast";
import {assignment, getPostStat, getUser, submission, task} from "../../api/app";
import {capitalize} from "../../utils/capitalize";
import DTTask from "../../components/layout/DTTask";
import UserReport from "../../components/analytic/UserReport";
import {useSelector} from "react-redux";
import formatNumber from "../../utils/formatNumber";

const searchableFields = [
    { field: 'first_name', isNumeric: false },
    { field: 'last_name', isNumeric: false },
    { field: 'full_name', isNumeric: false },
    { field: 'contact_number', isNumeric: false },
    { field: 'agent.name', isNumeric: true },
    { field: 'agent.username', isNumeric: true },
    { field: 'id_number', isNumeric: false }
];

let currentDateRange = null;
let filter = {};

const UserData = (props) => {

    const token = localStorage.getItem('jwtToken');

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const [id, setId] = useState(new Date().getTime());
    const auth = useSelector((state) => state.auth.user);
    const [datatable] = useState({
        task: false,
        submission: false,
        report: false
    });

    useEffect(() => {
        getUser(props.match.params.id).then((response) => {
            if (!response.error) {
                filter = {
                    user: `ObjectId(${props.match.params.id})`
                }
                setUserData(response.payload.user);
                setLoading(false);
            }
        });
    }, [reset]);

    const taskDatatable = () => {
        if(datatable.task) return false;
        datatable.task = true;

        let table = $('#task-datatable').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Task Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "task",
                        searchableFields,
                        filter,
                        populate: [
                            {
                                path: "assignment",
                                model: "assignment"
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.assignment?.subject;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data?.assignment?.social;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            'awaiting' : `<span class="badge badge-primary tx-white">Awaiting</span>`,
                            'pending' : `<span class="badge badge-warning tx-white">Pending</span>`,
                            'completed' : `<span class="badge badge-success tx-white">Completed</span>`,
                            'rejected' : `<span class="badge badge-danger tx-white">Rejected</span>`
                        }[data.status];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date).format("Do MMM, YYYY")
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `${data.status === "awaiting" ? `<nav class="nav nav-icon-only"><a href="#" class="nav-link approve"><i class="fa fa-check"></i> Approve</a> <a href="#" class="nav-link reject"><i class="fa fa-ban"></i> Reject</a></nav>` : `<nav class="nav nav-icon-only"><span href="#" class="nav-link"><i class="fa fa-ban"></i> No Action</span></nav>`}`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.approve', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            let id = extract_td?.raw?.task_id;

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            let data = {
                id,
                action: "completed"
            }

            task("put", data).then((result) => {
                hide();
                if(!result.error) {
                    $('#task-datatable').DataTable().ajax.reload(null, false);
                    cogoToast.success("Task successfully approved.", {position: "top-right"});
                }
            });
        });

        $('#task-datatable tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d?.raw?.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '</table>'
            );
        }
    }

    const submissionDatatable = () => {
        if(datatable.submission) return false;
        datatable.submission = true;

        let table = $('#submission-datatable').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Submission Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "submission",
                        searchableFields,
                        filter: {
                            user: `ObjectId(${userData._id})`
                        },
                        populate: [
                            {
                                path: "task",
                                model: "task",
                                populate: {
                                    path: "assignment",
                                    model: "assignment",
                                }
                            },
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data?.task?.assignment?.social || "Task not found");
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Approved</span>`,
                            false : `<span class="badge badge-primary tx-white">Awaiting</span>`
                        }[data.approve];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="${data.url}" class="nav-link" target="_blank"><i class="fa fa-eye"></i> View Link</a></nav>`
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY")
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"> <a href="#" class="nav-link insight-report"><i class="fa fa-info-circle"></i> Report</a> <a href="#" class="nav-link delete_submission"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_submission', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this submission?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                submission("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        $('#submission-datatable').DataTable().ajax.reload(null, false);
                        cogoToast.success("Submission successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.insight-report', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();

            let {hide} = cogoToast.loading('Please wait... contacting to facebook server.', {
                position: "top-right",
                hideAfter: 0
            });

            getPostStat(extract_td.raw._id).then((response) => {
                hide();
                if(!response.error) {
                    const {likes, comments, shares, reactions, engagements, page} = response.payload;

                    $("#total-likes").text(likes);
                    $("#total-comments").text(comments);
                    $("#total-shares").text(shares);
                    $("#total-reactions").text(reactions);
                    $("#total-engagements").text(engagements);

                    //Page Info
                    $("#page-name-1").text(page.name);
                    $("#page-category-1").text(page.category);
                    $("#page-follower-1").text(page.followers_count);
                    $('#page-logo-1').attr('src', page.picture.data.url);
                    $('#page-link-1').attr('href', `https://www.facebook.com/${page.id}`);

                    $("#modalInsightReport").modal({ backdrop: 'static', focus: false, show: true });
                }
            });
        })

        $('#submission-datatable tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            if(d.raw?.task && Object.keys(d.raw.task).length === 0) {
                return (
                    '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td>Subject:</td>' +
                    '<td>' +
                    'No Task Found' +
                    '</td>'+
                    '</tr>' +
                    '</tr>' +
                    '</table>'
                )
            }

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Subject:</td>' +
                '<td>' +
                d.raw?.task?.assignment?.subject +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d.raw?.task?.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Type:</td>' +
                '<td class="text-capitalize">' +
                d.raw?.task?.assignment?.type +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '</table>'
            );
        }
    }

    const handleFilterSelect = (value, name) => {
        filter = Object.assign(filter, {
            status: value
        });

        $("#tx-filter-level").text(name);
        $('#task-datatable').DataTable().ajax.reload();
    }

    if(!loading) {
        return (
            <div className="content-body">
                <div className="container-fluid pd-x-0">
                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                    <li className="breadcrumb-item"><a href="#">Team</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-none d-md-block">
                            <span className="badge badge-success tx-white">Active</span>
                        </div>
                    </div>

                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div className="media">
                            <div className="media-body my-auto">
                                <h5 className="mg-b-5 text-capitalize">{userData.name}</h5>
                                <p className="mg-b-3 text-capitalize">
                                    App User (Influencer)<br/>
                                    {auth.user.role === 'admin' ? userData.admin.name : null}<br/>
                                    <span className="tx-medium tx-color-02 text-capitalize">{moment(userData.createdAt).format("Do MMM, YYYY")}</span><br/>
                                </p>
                                <span className="d-block tx-13 tx-color-03">{userData.email}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row row-xs">
                        <div className="col-md-12 mg-t-10">
                            <div className="nav-wrapper mg-b-20 tx-13">
                                <div>
                                    <ul id="nav_basic" className="nav nav-line nav-fill tx-medium">
                                        <li className="nav-item"><a href="#basic " className="nav-link active" data-toggle="tab"><i className="ion-md-information-circle"/> Report</a></li>
                                        <li className="nav-item"><a href="#task" className="nav-link" data-toggle="tab" onClick={taskDatatable.bind()}><i className="ion-md-person"/> Tasks</a></li>
                                        <li className="nav-item"><a href="#submission" className="nav-link" data-toggle="tab" onClick={submissionDatatable.bind()}><i className="ion-md-person"/> Submissions</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="tab-content">
                                <div id="basic" className="tab-pane fade active show">
                                    <div className="row row-sm">
                                        <UserReport id={userData._id}/>
                                    </div>
                                </div>

                                <div id="task" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Task List</h6>
                                                    <div className="d-flex tx-18">

                                                        <div className="tx-12 tx-color-03 align-items-center d-none d-sm-flex mg-r-10">
                                                            <div className="dropdown mr-2">
                                                                <a href="javascript:void(0)" className="link-01 tx-spacing-1 tx-rubik d-flex align-items-center dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-filter-level">Filter By</span></a>
                                                                <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "awaiting", "Awaiting")}>Awaiting</a>
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "pending", "Pending")}>Pending</a>
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "completed", "Completed")}>Completed</a>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex tx-18">
                                                                <a href="#" onClick={(e) => {e.preventDefault(); $('#task-table').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <table id="task-datatable" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Subject</th>
                                                            <th className="wd-20p">Social</th>
                                                            <th className="wd-20p">Status</th>
                                                            <th className="wd-20p">Date</th>
                                                            <th className="wd-20p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="submission" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Submission</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="#" onClick={(e) => {e.preventDefault(); $('#submission-datatable').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="submission-datatable" className="table" width={"100%"}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Social</th>
                                                            <th className="wd-20p">Status</th>
                                                            <th className="wd-20p">Link</th>
                                                            <th className="wd-20p">Date</th>
                                                            <th className="wd-20p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel6">Assignment Tasks</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <DTTask id={id}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalInsightReport" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel6">Stats Report</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <div className="col-sm-6 col-lg-3">
                                            <div className="card card-body pd-15">
                                                <span className="tx-20 tx-color-02"><i className="fa fa-thumbs-up tx-success"></i></span>
                                                <h3 id="total-likes" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 mb-2">0</h3>
                                                <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">Likes</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <div className="card card-body pd-15">
                                                <span className="tx-20 tx-color-02"><i className="fa fa-comment tx-warning"></i></span>
                                                <h3 id="total-comments" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 mb-2">0</h3>
                                                <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">Comments</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <div className="card card-body pd-15">
                                                <span className="tx-20 tx-color-02"><i className="fa fa-share tx-primary"></i></span>
                                                <h3 id="total-shares" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 mb-2">0</h3>
                                                <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">Shares</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <div className="card card-body pd-15">
                                                <span className="tx-20 tx-color-02"><i className="fa fa-heart tx-danger"></i></span>
                                                <h3 id="total-reactions" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 mb-2">0</h3>
                                                <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">Reactions</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div>
                                        <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Engagement</h6>
                                        <p className="tx-14 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-engagements">0</p>
                                    </div>
                                    <hr/>
                                    <div>
                                        <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-10 mg-md-b-8">Page Info</h6>
                                        <a href={`https://www.facebook.com/`} target="_blank" className="link-02" id="page-link-1">
                                            <div className="d-flex justify-content-between mt-3">
                                                <div className="media">
                                                    <div className="crypto-icon crypto-icon-sm bg-primary">
                                                        <img id="page-logo-1" src="" className="ht-50 rounded-30" alt="logo"/>
                                                    </div>
                                                    <div className="media-body mg-l-15">
                                                        <p className="tx-medium mg-b-0" id="page-name">Name</p>
                                                        <p className="mg-b-0 tx-12 tx-color-03 tx-medium tx-spacing-1" id="page-category-1">Category</p>
                                                    </div>
                                                </div>
                                                <div className="text-end">
                                                    <p className="tx-normal tx-rubik mg-b-0">Follower</p>
                                                    <p className="tx-normal tx-rubik mg-b-0 float-right" id="page-follower-1">0</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                         aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes,
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-danger btn-block mt-0"
                                            data-dismiss="modal">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="content-body">
            <div className="container d-flex justify-content-center ht-100p">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mg-t-10">Collecting Data</p>
                </div>
            </div>
        </div>
    )
};

export default UserData;
